<template>
  <v-footer color="grey-lighten-4">
    <v-spacer></v-spacer>
    <div align="center">
      <v-img src="@/assets/ntt_docomo_business_x-logo.png" width="254" height="50"></v-img>
      <div class="text-caption">Copyright© NTT DOCOMO BUSINESS X, Inc.</div>
    </div>
  </v-footer>
</template>
<script></script>
<style scoped>
.v-footer {
  flex: 0;
  padding: 10px 14px;
}
.v-footer .text-caption {
  margin-top: 10px;
  font-size: 0.65rem !important;
  line-height: 0.65rem;
}
</style>
